import gql from 'graphql-tag';

export const GET_INSTALLATION_MONITORING_STORES = gql`
  query InstallationMonitoringStores($input: InstallationMonitoringStoresInput!) {
    installationMonitoringStores(input: $input)
  }
`;
export const GET_INSTALLATION_MONITORING_EVENTS = gql`
  query InstallationMonitoringEvents($input: InstallationMonitoringEventsInput!) {
    installationMonitoringEvents(input: $input)
  }
`;

export const GET_RETURN_EXCHANGE_INCENTIVE_SETTINGS = gql`
  query ReturnExchangeIncentiveSettings($input: ReturnExchangeIncentiveSettingsInput!) {
    returnExchangeIncentiveSettings(input: $input) {
      storeId
      revision
      settings
    }
  }
`;

export const GET_RETURN_EXCHANGE_PROCESSING_POLICY = gql`
  query ReturnExchangePolicySettings($input: ReturnExchangePolicySettingsInput!) {
    returnExchangePolicySettings(input: $input) { version storeId revision enabled trigger }
  }
`;

export const GET_RETURN_NATIVE_EXCHANGE_STATUS = gql`
  query ReturnNativeExchangeStatus($input: ReturnNativeExchangeStatusInput!) {
    returnNativeExchangeStatus(input: $input)
  }
`;

export const GET_RETURN_KEEP_ITEM_CREDIT_STATUS = gql`
  query ReturnKeepItemCreditStatus($input: ReturnKeepItemCreditStatusInput!) {
    returnKeepItemCreditStatus(input: $input)
  }
`;

export const GET_RETURN_EXCHANGE_CUSTOMER_POLICY_SETTINGS=gql`
  query ReturnExchangeCustomerPolicySettings($input: ReturnExchangeCustomerPolicySettingsInput!) {
    returnExchangeCustomerPolicySettings(input:$input) { storeId revision configured policy }
  }
`;
export const GET_RETURN_EXCHANGE_ORIGINAL_CATALOG=gql`
  query ReturnExchangeOriginalCatalog($input: ReturnExchangeOriginalCatalogInput!) {
    returnExchangeOriginalCatalog(input:$input)
  }
`;

export const GET_ASSISTED_INSTALLATION_WORKSPACE = gql`
  query AssistedInstallationWorkspace($input: AssistedInstallationStoreInput!) {
    assistedInstallationWorkspace(input: $input)
  }
`;
export const GET_ASSISTED_INSTALLATION_QUEUE = gql`
  query AssistedInstallationQueue {
    assistedInstallationQueue
  }
`;

export const GET_INSTALLATION_FEATURE_SETTINGS = gql`
  query installationFeatureSettings($storeId: uuid!) {
    store(id: $storeId) {
      id
      store
      currency
      uninstalledAt
      features
      freeGifts
      policySettings
    }
  }
`;

export const GET_RETURN_DEFECT_RESOLUTION = gql`
  query getReturnDefectResolution($input: GetReturnDefectResolutionInput!) {
    getReturnDefectResolution(input: $input) {
      version
      updatedAt
      recordStatus
      evidenceStatus
      evidenceRevision
      financialPreview
      policy
      capabilities
      plan
      informationRequest
      history
    }
  }
`;

export const GET_RETURN_SIZE_EXCHANGE_ESTIMATE = gql`
  query returnSizeExchangeEstimate($input: ReturnSizeExchangeEstimateInput!) {
    returnSizeExchangeEstimate(input: $input) {
      status
      reason
      replacementVariantId
      quantity
      currencyCode
      taxesIncluded
      returnSubtotal
      returnTax
      replacementSubtotal
      replacementTax
    }
  }
`;

export const GET_RETURN_SIZE_EXCHANGE_PREVIEW = gql`
  query returnSizeExchangePreview($input: ReturnSizeExchangePreviewInput!) {
    returnSizeExchangePreview(input: $input) {
      status
      reason
      productTitle
      originalVariantId
      sizeOptionName
      candidates {
        variantId
        title
        size
        sku
      }
    }
  }
`;

export const RETURN_LABEL_PURCHASE_PREVIEW = gql`
  query returnLabelPurchasePreview($input: ReturnLabelPurchasePreviewInput!) {
    returnLabelPurchasePreview(input: $input) {
      returnId
      storeId
      returnUpdatedAt
      purchaseRequired
      canPurchase
      blockedReason
      quotedAt
      source
      carrier
      service
      carrierAmount
      carrierCurrency
      shipaidFeeAmount
      shipaidFeeCurrency
      estimatedTotal
      totalCurrency
      billingMode
    }
  }
`;

export const GET_RETURN_CUSTOMER_RESTRICTIONS = gql`
  query returnCustomerRestrictions($storeId: String!) {
    returnCustomerRestrictions(storeId: $storeId) {
      storeId
      enabled
      customerTags
      blockedEmails
      blockedCustomers {
        orderId
        orderNumber
        customerId
        email
        customerName
      }
    }
  }
`;

export const GET_RETURN_CUSTOMER_RESTRICTION_ORDER = gql`
  query returnCustomerRestrictionOrder($storeId: String!, $orderNumber: String!) {
    returnCustomerRestrictionOrder(storeId: $storeId, orderNumber: $orderNumber) {
      orderId
      orderNumber
      customerId
      email
      customerName
    }
  }
`;

export const MERCHANT_REQUESTS = gql`
  query merchantRequests($input: MerchantRequestsInput!) {
    merchantRequests(input: $input) {
      storeId
      totalCount
      limit
      offset
      hasMore
      counts {
        group
        count
      }
      nodes {
        id
        type
        number
        orderId
        shopifyOrderId
        orderNumber
        customerName
        customerEmail
        summary
        orderEditingRequest
        status
        statusLabel
        outcome
        requestedResolution
        group
        nextAction
        nextActionLabel
        responsibleParty
        createdAt
        updatedAt
        dueAt
        settlementStatus
        settlementType
        items {
          orderItemId
          title
          quantity
          reason
          requestedResolution
          resolution
        }
      }
    }
  }
`;

export const GET_ORDER_EDITING_CATALOG = gql`
  query OrderEditingCatalog($input: OrderEditingCatalogInput!) {
    orderEditingCatalog(input: $input)
  }
`;

export const GET_ORDER_EDITING_WORKSPACE = gql`
  query OrderEditingWorkspace($input: OrderEditingWorkspaceInput!) {
    orderEditingWorkspace(input: $input)
  }
`;

export const GET_STORES = gql`
  query stores {
    stores {
      id
      name
      plan {
        active
      }
      store
      shouldUpdateAppInstall
      isStoreShopifyPlus
      logoUrl
      uninstalledAt
      domains {
        id
        domain
      }
      completedSteps
    }
  }
`;

export const GET_USER_MFA_STATUS = gql`
  query userMfaStatus($id: uuid!) {
    user(id: $id) {
      id
      activeMfaType
    }
  }
`;

export const GET_USER_STORE_NOTIFICATIONS = gql`
  query storeUserNotifications($storeId: uuid!) {
    storeUserNotifications(where: { storeId: { _eq: $storeId } }) {
      claimNew
      claimRefund
      claimReorder
      claimStatus
      returnFiled
      returnDroppedOff
      returnInTransit
      returnDelivered
      returnReceived
      returnProcessed
      returnExpired
      returnFlagged
      returnAwaitingApproval
      id
      storeId
      userId
      store {
        users {
          user {
            avatarUrl
            displayName
            email
            id
            notifications {
              id
            }
          }
          userRole {
            role
          }
        }
      }
      user {
        avatarUrl
        displayName
        email
        id
      }
    }
  }
`;
export const GET_USER_ROLE = gql`
  query storeRoles($storeId: uuid!, $userId: uuid!) {
    storeRoles(
      where: {
        stores: { storeId: { _eq: $storeId }, userId: { _eq: $userId } }
      }
    ) {
      role
    }
  }
`;

export const GET_PROTECTION_SETTINGS = gql`
  query protectionSettings($storeId: uuid!) {
    protectionSettings(where: { storeId: { _eq: $storeId } }) {
      defaultFee
      highestOrderValue
      minimumFee
      maximumFee
      percentage
      protectionType
      storeId
      updatedAt
      id
      rules
    }
  }
`;

export const GET_EASYSHIP_CONNECTION = gql`
  query getEasyshipConnection($input: EasyshipConnectionInput!) {
    getEasyshipConnection(input: $input) {
      id
      storeId
      connected
      status
      scope
      tokenType
      expiresAt
      connectedAt
      disconnectedAt
      lastRefreshedAt
      lastError
      account
      meta
    }
  }
`;

export const MERCHANT_TRACKING_DETAIL = gql`
  query merchantTrackingDetail(
    $trackingNumber: String!
    $ownerType: MerchantTrackingOwnerType!
    $ownerId: String!
  ) {
    merchantTrackingDetail(
      trackingNumber: $trackingNumber
      ownerType: $ownerType
      ownerId: $ownerId
    ) {
      trackingNumber
      ownerType
      ownerId
      ownerNumber
      ownerPath
      status
      statusLabel
      progressStage
      carrier
      service
      eta
      lastUpdatedAt
      carrierTrackingUrl
      stale
      unmapped
      warnings {
        code
        message
      }
      checkpoints {
        occurredAt
        status
        message
        location
      }
      items {
        id
        title
        sku
        quantity
        imageUrl
      }
    }
  }
`;

export const GET_RETURN_SHIPPING_OPTIONS_SETTINGS = gql`
  query getReturnShippingOptionsSettings(
    $input: ReturnShippingOptionsStoreInput!
  ) {
    getReturnShippingOptionsSettings(input: $input) {
      storeId
      fallbackBehavior
      enabledOptions {
        id
        source
        courierServiceId
        carrier
        service
        displayName
        enabled
        customerVisible
        sortOrder
        meta
      }
    }
  }
`;

export const EASYSHIP_RETURN_CARRIER_SERVICES = gql`
  query easyshipReturnCarrierServices(
    $input: ReturnShippingCarrierServicesInput!
  ) {
    easyshipReturnCarrierServices(input: $input) {
      storeId
      services {
        id
        source
        carrier
        service
        displayName
        active
        domestic
        international
        countries
        meta
      }
      sources {
        source
        status
        message
      }
    }
  }
`;

export const SHOPIFY_RETURN_LOCATIONS = gql`
  query shopifyReturnLocations($input: ShopifyReturnLocationsInput!) {
    shopifyReturnLocations(input: $input) {
      storeId
      locations {
        id
        label
        street
        street1
        street2
        country
        country_alpha2
        city
        state
        zip
        phone
        email
        isDefault
        source
        shopifyLocationId
      }
    }
  }
`;

export const EASYSHIP_LYOC_STATUS = gql`
  query easyshipLyocStatus($input: EasyshipLyocStoreInput!) {
    easyshipLyocStatus(input: $input) {
      storeId
      connected
      status
      easyshipCompanyId
      lastError
      linkedCouriers {
        id
        name
        carrier
        state
        authState
        active
        countryAlpha2
        accountNumber
        meta
      }
    }
  }
`;

export const EASYSHIP_LYOC_SUPPORTED_CARRIERS = gql`
  query easyshipLyocSupportedCarriers(
    $input: EasyshipLyocSupportedCarriersInput!
  ) {
    easyshipLyocSupportedCarriers(input: $input) {
      storeId
      carriers {
        key
        name
        logoUrl
        countryAlpha2
        courierId
        creation {
          api
          ui
          contact
        }
      }
    }
  }
`;

export const QUOTE_RETURN_SHIPPING_OPTIONS = gql`
  query quoteReturnShippingOptions($input: QuoteReturnShippingOptionsInput!) {
    quoteReturnShippingOptions(input: $input) {
      errorCode
      errorMessage
      storeId
      orderId
      fallbackBehavior
      options {
        id
        source
        courierServiceId
        rateId
        carrier
        service
        displayName
        amount
        currency
        minDeliveryTime
        maxDeliveryTime
        estimatedDeliveryDate
        customerVisible
        sortOrder
        meta
      }
      sources {
        source
        status
        message
      }
    }
  }
`;

/************
 *
 * ORDERS query
 * **********
 */

export const GET_ORDERS = gql`
  query orders(
    $storeId: uuid!
    $limit: Int
    $offset: Int
    $order_by: [orders_order_by]!
  ) {
    orders(
      where: { storeId: { _eq: $storeId } }
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      isReorder
      cancelledAt
      number
      orderId
      protectionStatus
      protectionTotal
      total
      customerName
      customerEmail
      customerPhone
      createdAt
      id
      subtotal
      trackingStatus
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        defaultTrackingUrl
        status
        trackerId
        trackerStatus
        estDeliveryDate
        orderItem {
          title
          quantity
        }
      }
      claims(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
      }
      claimsAggregate: claims_aggregate {
        aggregate {
          count
        }
      }
      returnsAggregate: returns_aggregate {
        aggregate {
          count
        }
      }
      openClaims: claims(
        where: { status: { _nin: [RESOLVED, DENIED, ARCHIVED] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
      }
      openReturns: returns(
        where: { status: { _nin: ["RESOLVED", "DENIED", "EXPIRED"] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
        requestedResolution
        returnItems {
          requestedResolution
        }
      }
      returns(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
        requestedResolution
        createdAt
        returnItems {
          requestedResolution
        }
      }
      items {
        id
        trackingId
        title
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
    }
    ordersAggregate(where: { storeId: { _eq: $storeId } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_ORDERS_COUNT = gql`
  query getOrdersCount(
    $totalOrdersWhere: orders_bool_exp!
    $unprotectedOrdersWhere: orders_bool_exp!
    $protectedOrdersWhere: orders_bool_exp!
  ) {
    totalOrders: ordersAggregate(where: $totalOrdersWhere) {
      aggregate {
        total: count
      }
    }
    unprotectedOrders: ordersAggregate(where: $unprotectedOrdersWhere) {
      aggregate {
        total: count
      }
    }
    protectedOrders: ordersAggregate(where: $protectedOrdersWhere) {
      aggregate {
        total: count
      }
    }
  }
`;

export const GET_ORDERS_BY = gql`
  query orders(
    $order_by: [orders_order_by]!
    $storeId: uuid!
    $limit: Int
    $offset: Int
  ) {
    orders(
      order_by: $order_by
      where: { storeId: { _eq: $storeId } }
      limit: $limit
      offset: $offset
    ) {
      isReorder
      number
      cancelledAt
      orderId
      protectionStatus
      protectionTotal
      customerName
      customerEmail
      customerPhone
      createdAt
      id
      subtotal
      trackingStatus
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        defaultTrackingUrl
        status
        trackerId
        trackerStatus
        estDeliveryDate
        orderItem {
          title
          quantity
        }
      }
      claims(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
      }
      claimsAggregate: claims_aggregate {
        aggregate {
          count
        }
      }
      returnsAggregate: returns_aggregate {
        aggregate {
          count
        }
      }
      openClaims: claims(
        where: { status: { _nin: [RESOLVED, DENIED, ARCHIVED] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
      }
      openReturns: returns(
        where: { status: { _nin: ["RESOLVED", "DENIED", "EXPIRED"] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
        requestedResolution
        returnItems {
          requestedResolution
        }
      }
      returns(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
        requestedResolution
        createdAt
        returnItems {
          requestedResolution
        }
      }
      items {
        id
        title
        trackingId
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
    }
    ordersAggregate(
      order_by: $order_by
      where: { storeId: { _eq: $storeId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_ORDER_BY_ID = gql`
  query orders($storeId: uuid!, $id: uuid!, $limit: Int, $offset: Int) {
    orders(
      where: { storeId: { _eq: $storeId }, id: { _eq: $id } }
      limit: $limit
      offset: $offset
    ) {
      storeId
      number
      orderId
      protectionStatus
      protectionTotal
      total
      discountTotal
      customerName
      customerEmail
      customerPhone
      isReorder
      cancelledAt
      createdAt
      updatedAt
      id
      subtotal
      paymentCurrencyCode
      claims {
        id
      }
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        defaultTrackingUrl
        trackerStatus
        estDeliveryDate
        orderItem {
          title
          quantity
        }
      }
      items {
        imageSrc
        orderId
        price
        quantity
        sku
        subtotal
        tax
        taxTotal
        title
        total
        updatedAt
        id
        fulfillmentStatus
        fulfilledAt
        trackingUrl
        trackingId
        variantId
        deliveredAt
        estimatedDeliveredAt
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
      shippingAddress
    }
  }
`;

export const GET_PROTECTED_ORDERS_WITH_NO_CLAIMS = gql`
  query orders($storeId: uuid!, $number: String, $limit: Int) {
    orders(
      where: {
        storeId: { _eq: $storeId }
        number: { _ilike: $number }
        _not: { claims: {} }
      }
      limit: $limit
    ) {
      number
      orderId
      protectionStatus
      protectionTotal
      total
      customerName
      customerEmail
      customerPhone
      isReorder
      createdAt
      updatedAt
      cancelledAt
      id
      subtotal
      claims {
        id
      }
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        trackerStatus
        estDeliveryDate
      }
      items {
        imageSrc
        orderId
        price
        quantity
        sku
        subtotal
        tax
        taxTotal
        title
        total
        updatedAt
        id
        fulfillmentStatus
        fulfilledAt
        trackingUrl
        trackingId
        variantId
        deliveredAt
        estimatedDeliveredAt
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
    }
  }
`;

export const GET_ORDER_BY_NUMBER = gql`
  query orders($storeId: uuid!, $number: String!) {
    orders(where: { storeId: { _eq: $storeId }, number: { _eq: $number } }) {
      number
      orderId
      protectionStatus
      protectionTotal
      total
      discountTotal
      customerName
      customerEmail
      customerPhone
      isReorder
      createdAt
      updatedAt
      id
      cancelledAt
      subtotal
      claims {
        id
      }
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        trackerStatus
        estDeliveryDate
      }
      items {
        imageSrc
        orderId
        price
        quantity
        sku
        subtotal
        tax
        taxTotal
        title
        total
        updatedAt
        id
        fulfillmentStatus
        fulfilledAt
        trackingUrl
        trackingId
        variantId
        deliveredAt
        estimatedDeliveredAt
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
    }
  }
`;

export const FILTER_ORDERS = gql`
  query orders(
    $filters: orders_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [orders_order_by]!
  ) {
    orders(
      where: $filters
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      number
      isReorder
      orderId
      protectionStatus
      protectionTotal
      total
      customerName
      customerEmail
      customerPhone
      isReorder
      createdAt
      id
      subtotal
      cancelledAt
      trackingStatus
      trackings(where: { status: { _eq: "ACTIVE" } }) {
        trackingNumber
        trackingCompany
        defaultTrackingUrl
        status
        trackerId
        trackerStatus
        estDeliveryDate
        orderItem {
          title
          quantity
        }
      }
      claims(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
      }
      claimsAggregate: claims_aggregate {
        aggregate {
          count
        }
      }
      returnsAggregate: returns_aggregate {
        aggregate {
          count
        }
      }
      openClaims: claims(
        where: { status: { _nin: [RESOLVED, DENIED, ARCHIVED] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
      }
      openReturns: returns(
        where: { status: { _nin: ["RESOLVED", "DENIED", "EXPIRED"] } }
        order_by: { createdAt: desc }
        limit: 2
      ) {
        id
        number
        status
        requestedResolution
        returnItems {
          requestedResolution
        }
      }
      returns(order_by: { createdAt: desc }, limit: 2) {
        id
        number
        status
        requestedResolution
        createdAt
        returnItems {
          requestedResolution
        }
      }
      items {
        id
        title
        trackingId
      }
      treeDetails
      activities {
        eventType
        createdAt
      }
    }
    ordersAggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_PROTECTED_ORDERS_COUNT = gql`
  query protectedOrders($filters: orders_bool_exp) {
    ordersAggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

/************
 *
 * CLAIM queries
 * **********
 */

export const GET_CLAIM = gql`
  query claims($storeId: uuid!, $id: uuid!) {
    claims(where: { storeId: { _eq: $storeId }, id: { _eq: $id } }) {
      createdAt
      date
      id
      notes
      customerNotes
      number
      orderId
      status
      storeId
      tags
      reason
      updatedAt
      total
      preferredResolution
      preferredResolutionNotes
      suggestedRefund
      createdBy {
        displayName
        id
      }
      images(order_by: { createdAt: desc }, limit: 5) {
        id
        url
      }
      videos(order_by: { createdAt: desc }, limit: 5) {
        id
        url
      }
      items {
        id
        reason
        resolution
        total
        quantity
        settlement {
          quantity
          claimItem {
            quantity
          }
          solvedByRule {
            title
          }
        }
        orderItem {
          imageSrc
          price
          subtotal
          taxTotal
          total
          discountTotal
          sku
          quantity
          id
          title
          fulfillmentStatus
          fulfilledAt
          trackingUrl
          trackingId
          variantId
          deliveredAt
          estimatedDeliveredAt
        }
      }
      resolution
      settlements {
        id
        resolution
        notes
        metadata
        message
        items {
          id
          claimItem {
            id
            orderItem {
              price
              quantity
              sku
            }
          }
          metadata
          updated_at
        }
        updatedBy {
          displayName
          email
          id
          avatarUrl
        }
        updatedAt
      }
      activities {
        eventType
        createdAt
      }
      order {
        id
        number
        orderId
        customerName
        customerEmail
        customerPhone
        tax
        shippingTotal
        total
        discountTotal
        protectionStatus
        protectionTotal
        createdAt
        subtotal
        paymentCurrencyCode
        trackings(where: { status: { _eq: "ACTIVE" } }) {
          trackingNumber
          trackingCompany
          trackerStatus
          estDeliveryDate
        }
        items {
          updatedAt
          total
          discountTotal
          title
          taxTotal
          tax
          subtotal
          sku
          quantity
          price
          orderId
          imageSrc
          id
          createdAt
          fulfillmentStatus
          fulfilledAt
          trackingUrl
          trackingId
        }
      }
    }
    claimsAggregate {
      aggregate {
        count
      }
    }
  }
`;

export const GET_CLAIMS = gql`
  query claims(
    $storeId: uuid!
    $limit: Int
    $offset: Int
    $order_by: [claims_order_by]!
  ) {
    claims(
      where: { storeId: { _eq: $storeId } }
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      createdAt
      date
      id
      notes
      number
      orderId
      status
      storeId
      tags
      reason
      updatedAt
      total
      images {
        id
      }
      videos {
        id
      }
      items {
        id
      }
      resolution
      order {
        number
        customerName
        customerEmail
        customerPhone
        protectionTotal
        total
        protectionStatus
        createdAt
        trackings(where: { status: { _eq: "ACTIVE" } }) {
          trackingNumber
        }
        items {
          id
          trackingId
        }
      }
    }
    claimsAggregate(where: { storeId: { _eq: $storeId } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_CLAIMS_COUNT = gql`
  query getClaimsCount($storeId: uuid!) {
    totalClaims: claimsAggregate(where: { storeId: { _eq: $storeId } }) {
      aggregate {
        count
      }
    }
    resolvedClaims: claimsAggregate(
      where: { storeId: { _eq: $storeId }, status: { _eq: RESOLVED } }
    ) {
      aggregate {
        count
      }
    }
    newClaims: claimsAggregate(
      where: { storeId: { _eq: $storeId }, status: { _eq: NEW } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_REQUEST_ISSUE_METRICS = gql`
  query getRequestIssueMetrics(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    totalClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        count
      }
    }
    newClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: NEW }
      }
    ) {
      aggregate {
        count
      }
    }
    inReviewClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: IN_REVIEW }
      }
    ) {
      aggregate {
        count
      }
    }
    resolvedClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: RESOLVED }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_CLAIMS_BY = gql`
  query claims($order_by: [claims_order_by]!, $storeId: uuid!) {
    claims(order_by: $order_by, where: { storeId: { _eq: $storeId } }) {
      createdAt
      date
      id
      notes
      number
      orderId
      status
      storeId
      tags
      reason
      updatedAt
      total
      images {
        id
      }
      videos {
        id
      }
      items {
        id
      }
      resolution
      order {
        number
        customerName
        customerEmail
        customerPhone
        total
        protectionStatus
        protectionTotal
        createdAt
        trackings(where: { status: { _eq: "ACTIVE" } }) {
          trackingNumber
        }
      }
    }
    claimsAggregate(
      where: { storeId: { _eq: $storeId } }
      order_by: $order_by
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_RESOLVED_CLAIMS_COUNT = gql`
  query claims($storeId: uuid!, $statusType: claim_statuses_enum!) {
    claimsAggregate(
      where: { storeId: { _eq: $storeId }, statusType: { _eq: $statusType } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const FILTER_CLAIMS = gql`
  query claims(
    $filters: claims_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [claims_order_by]!
  ) {
    claims(
      where: $filters
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      createdAt
      date
      id
      notes
      number
      orderId
      status
      storeId
      reason
      tags
      total
      updatedAt
      images {
        id
      }
      videos {
        id
      }
      items {
        id
      }
      resolution
      order {
        number
        customerName
        customerEmail
        customerPhone
        total
        protectionStatus
        protectionTotal
        createdAt
        trackings(where: { status: { _eq: "ACTIVE" } }) {
          trackingNumber
        }
      }
    }
    claimsAggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

/************
 *
 * STORE queries
 * **********
 */

export const GET_WAYFLYER_COMPANY_SESSION = gql`
  query wayflyerCompanySession($storeId: String!) {
    wayflyerCompanySession(input: { storeId: $storeId }) {
      companyToken
      isSandbox
    }
  }
`;

export const GET_STORE_PROPERTIES = gql`
  query store($storeId: uuid!) {
    store(id: $storeId) {
      orderSettings {
        deadline
        shipping
      }
      storeClaimsSettings {
        notifyCustomerChecked
      }
      users {
        user {
          avatarUrl
          displayName
          email
          id
        }
        role
      }
      shouldUpdateAppInstall
      isStoreShopifyPlus
      completedSteps
      contactEmail
      contactPhone
      createdAt
      currency
      id
      name
      invites {
        email
        user {
          displayName
        }
      }
      url
      logoUrl
      bannerUrl
      policyUrl
      requireDeliveryGuaranteePolicy
      policySettings
      returnNotificationsSettings
      incentiveSettings
      resolvePortalOptions
      customResolutionNotes
      enableCustomAppFlow
      customAppInstallLink
      useCustomApp
      embedScriptSettings
      billing
      onboarding
      greenProtection
      freeGifts
      checkoutPlus
      addToCartPlus
      shippingPlus
      freeGifts
      plan {
        active
        chargeUrl
        chargeConfirmed
        createdAt
        endDate
        id
        startDate
        storeId
        planId
      }
      protectionSettings {
        protectionType
        variantIds
      }
      store
      type
      itemFulfillmentImmediate
      widgetAutoOptIn
      widgetShowCart
      reordersDiscount
      excludedProductSkus
      excludedProductTags
      tagsExcludedCustomersAutoOptIn
      uninstalledAt
      trialEndsAt
      features
    }
  }
`;

export const GET_STORE_ANALYTICS = gql`
  query storeAnalytics(
    $storeId: uuid!
    $afterDate: timestamptz
    $beforeDate: timestamptz
  ) {
    totalOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
      }
    ) {
      nodes {
        createdAt
      }
      aggregate {
        total: count
      }
    }
    totalEditedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        activities: { eventType: { _neq: "ORDER_CREATED" } }
      }
    ) {
      aggregate {
        total: count
      }
    }
    protectedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        protectionTotal: { _is_null: false }
      }
    ) {
      nodes {
        protectionTotal
        createdAt
      }
      aggregate {
        total: count
      }
    }
    unprotectedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        protectionTotal: { _is_null: true }
      }
    ) {
      aggregate {
        total: count
      }
    }
    totalClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    newClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: NEW }
      }
    ) {
      aggregate {
        count
      }
    }
    reviewClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: IN_REVIEW }
      }
    ) {
      aggregate {
        count
      }
    }
    deniedClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: DENIED }
      }
    ) {
      aggregate {
        count
      }
    }
    resolvedClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: RESOLVED }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_STORE_ANALYTICS_BY_CHANNEL = gql`
  query storeAnalyticsByChannel(
    $storeId: uuid!
    $afterDate: timestamptz
    $beforeDate: timestamptz
    $channelFilter: String
  ) {
    totalOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
          {
            _or: [
              { channel: { _eq: $channelFilter } }
              { channel: { _is_null: true } }
            ]
          }
        ]
      }
    ) {
      nodes {
        createdAt
      }
      aggregate {
        total: count
      }
    }
    totalEditedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        activities: { eventType: { _neq: "ORDER_CREATED" } }
        _or: [
          { channel: { _eq: $channelFilter } }
          { channel: { _is_null: true } }
        ]
      }
    ) {
      aggregate {
        total: count
      }
    }
    protectedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
          {
            _or: [
              { channel: { _eq: $channelFilter } }
              { channel: { _is_null: true } }
            ]
          }
        ]
        protectionTotal: { _is_null: false }
      }
    ) {
      nodes {
        protectionTotal
        createdAt
      }
      aggregate {
        total: count
      }
    }
    unprotectedOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
          {
            _or: [
              { channel: { _eq: $channelFilter } }
              { channel: { _is_null: true } }
            ]
          }
        ]
        protectionTotal: { _is_null: true }
      }
    ) {
      aggregate {
        total: count
      }
    }
    totalClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    newClaims: claimsAggregate(
      where: { storeId: { _eq: $storeId }, status: { _eq: NEW } }
    ) {
      aggregate {
        count
      }
    }
    reviewClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: IN_REVIEW }
      }
    ) {
      aggregate {
        count
      }
    }
    deniedClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: DENIED }
      }
    ) {
      aggregate {
        count
      }
    }
    resolvedClaims: claimsAggregate(
      where: {
        storeId: { _eq: $storeId }
        _and: [
          { createdAt: { _gte: $afterDate } }
          { createdAt: { _lte: $beforeDate } }
        ]
        status: { _eq: RESOLVED }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_STORE_USER_INVITES = gql`
  query storeAnalytics($storeId: uuid!) {
    storeUserInvites(
      order_by: { createdAt: desc }
      where: { storeId: { _eq: $storeId } }
    ) {
      id
      email
      role
      createdAt
    }
  }
`;

export const GET_BILLING_PLANS = gql`
  query getBillingPlans($storeId: uuid!) {
    plans(
      order_by: { priceMonthly: asc }
      where: {
        _or: [{ public: { _eq: true } }, { storeId: { _eq: $storeId } }]
      }
    ) {
      id
      name
      priceMonthly
      description
      protectionPercentage
      terms
      extraDescription
      oldPrice
      storeId
      storesPlans(where: { storeId: { _eq: $storeId } }) {
        id
        active
      }
    }
  }
`;

export const GET_ORDERS_CLAIMS_COUNT = gql`
  query totalOrdersClaims($storeId: uuid!) {
    totalOrders: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        protectionTotal: { _is_null: false }
      }
    ) {
      aggregate {
        total: count
      }
    }
    totalClaims: claimsAggregate(
      where: { storeId: { _eq: $storeId }, status: { _eq: NEW } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

/************
 *
 * BILLS queries
 * **********
 */

export const GET_BILLINGS_DATA = gql`
  query getBillings($storeId: uuid!) {
    bills(
      where: { storeId: { _eq: $storeId } }
      order_by: { createdAt: desc }
    ) {
      amount
      billType
      createdAt
      currencyCode
      date
      id
      invoiceId
      invoicePdfId
      number
      paid
    }
  }
`;

export const GET_BILLING_INVOICE_LINK = gql`
  query InvoiceDownloadUrl(
    $storeId: String!
    $invoiceId: String
    $invoicePdfId: String
    $type: String
  ) {
    link: invoiceDownloadUrl(
      input: {
        storeId: $storeId
        invoiceId: $invoiceId
        invoicePdfId: $invoicePdfId
        type: $type
      }
    )
  }
`;

export const SEARCH_BILLINGS_DATA = gql`
  query searchBillings($storeId: uuid!, $value: String!) {
    bills(
      where: {
        number: { _cast: { String: { _ilike: $value } } }
        storeId: { _eq: $storeId }
      }
    ) {
      amount
      billType
      createdAt
      currencyCode
      date
      id
      invoiceUrl
      number
      paid
    }
  }
`;

export const FILTER_BILLINGS = gql`
  query filterBillings(
    $filters: bills_bool_exp
    $order_by: [bills_order_by!]!
  ) {
    bills(where: $filters, order_by: $order_by) {
      amount
      billType
      createdAt
      currencyCode
      date
      id
      invoiceUrl
      number
      paid
    }
  }
`;

/************
 *
 * DASHBOARD query
 * **********
 */

export const GET_DASHBOARD_ANALYTICS = gql`
  query DashboardAnalytics(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    allOrdersToday: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }
    protectedOrdersToday: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        protectionTotal: { _is_null: false }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }
    protectedOrders: orders(
      where: {
        storeId: { _eq: $storeId }
        protectionTotal: { _is_null: false }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
      }
      order_by: { createdAt: desc }
    ) {
      createdAt
      protectionTotal
    }
    protectionFees: protectionFeesAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        sum {
          amount
        }
      }
    }
    claimsPaid: claims(
      where: {
        storeId: { _eq: $storeId }
        resolution: { _in: [REFUND, REORDER, OTHER] }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      id
      createdAt
      number
      total
      order {
        number
        protectionTotal
      }
    }
  }
`;

export const GET_DASHBOARD_ANALYTICS_BY_CHANNEL = gql`
  query DashboardAnalyticsByChannel(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
    $channelFilter: String
  ) {
    allOrdersToday: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
        _or: [
          { channel: { _eq: $channelFilter } }
          { channel: { _is_null: true } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    protectedOrdersToday: ordersAggregate(
      where: {
        storeId: { _eq: $storeId }
        protectionTotal: { _is_null: false }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
        _or: [
          { channel: { _eq: $channelFilter } }
          { channel: { _is_null: true } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    protectedOrders: orders(
      where: {
        storeId: { _eq: $storeId }
        protectionTotal: { _is_null: false }
        isReorder: { _eq: false }
        createdAt: { _gte: $startDate, _lte: $endDate }
        cancelledAt: { _is_null: true }
        _or: [
          { channel: { _eq: $channelFilter } }
          { channel: { _is_null: true } }
        ]
      }
      order_by: { createdAt: desc }
    ) {
      createdAt
      protectionTotal
    }
    protectionFees: protectionFeesAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        sum {
          amount
        }
      }
    }
    claimsPaid: claims(
      where: {
        storeId: { _eq: $storeId }
        resolution: { _in: [REFUND, REORDER, OTHER] }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      id
      createdAt
      number
      total
      order {
        number
        protectionTotal
      }
    }
  }
`;

export const GET_RETURN_METRICS = gql`
  query getReturnMetrics(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    totalReturns: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        count
      }
    }
    needsReview: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: "SUBMITTED" }
      }
    ) {
      aggregate {
        count
      }
    }
    awaitingShipment: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _in: ["APPROVED", "AWAITING_DROPOFF", "LABEL_READY"] }
      }
    ) {
      aggregate {
        count
      }
    }
    inTransit: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: "IN_TRANSIT" }
      }
    ) {
      aggregate {
        count
      }
    }
    readyToRefund: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _eq: "RECEIVED" }
      }
    ) {
      aggregate {
        count
      }
    }
    complete: returnsAggregate(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
        status: { _in: ["RESOLVED", "DENIED", "EXPIRED"] }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_RETURN_ANALYTICS_REPORT = gql`
  query returnAnalytics($input: ReturnAnalyticsInput!) {
    returnAnalytics(input: $input)
  }
`;

export const GET_REQUEST_RETURNS_ANALYTICS = gql`
  query getRequestReturnsAnalytics(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    returns(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
      order_by: { createdAt: desc }
    ) {
      id
      labelCost
      returnItems {
        id
        orderItemId
        quantity
        reason
        orderItem {
          id
          title
          sku
          price
        }
      }
    }
  }
`;

export const GET_RETURNS_ANALYTICS = gql`
  query getReturnsAnalytics(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    returns(
      where: {
        storeId: { _eq: $storeId }
        createdAt: { _gte: $startDate, _lte: $endDate }
      }
      order_by: { createdAt: desc }
    ) {
      id
      number
      status
      labelCost
      createdAt
      updatedAt
      order {
        total
        currencyCode
        paymentCurrencyCode
      }
      returnItems {
        id
        orderItemId
        quantity
        reason
        reasonComments
        requestedResolution
        resolution
        orderItem {
          id
          title
          sku
          price
          imageSrc
        }
      }
    }
  }
`;

/************
 *
 * RECENT ACTIVITY query
 * **********
 */

export const GET_RECENT_ACTIVITY = gql`
  query RecentActivity($storeId: uuid!, $limit: Int = 10, $offset: Int = 0) {
    recentClaims: claims(
      where: { storeId: { _eq: $storeId } }
      order_by: { createdAt: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      number
      createdAt
      status
      order {
        number
      }
    }
    recentOrders: orders(
      where: {
        storeId: { _eq: $storeId }
        activities: { eventType: { _neq: "ORDER_CREATED" } }
      }
      order_by: { updatedAt: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      number
      updatedAt
      trackingStatus
      items {
        fulfillmentStatus
        deliveredAt
      }
      activities(order_by: { createdAt: desc }, limit: 1) {
        eventType
        createdAt
      }
    }
    recentInvoices: bills(
      where: { storeId: { _eq: $storeId } }
      order_by: { createdAt: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      number
      createdAt
      date
      amount
      currencyCode
    }
  }
`;

export const GET_HOME_ORDER_ACTIVITY = gql`
  query HomeOrderActivity($storeId: uuid!, $limit: Int = 5) {
    recentOrders: orders(
      where: {
        storeId: { _eq: $storeId }
        activities: { eventType: { _neq: "ORDER_CREATED" } }
      }
      order_by: { updatedAt: desc }
      limit: $limit
    ) {
      id
      storeId
      number
      updatedAt
      trackingStatus
      items {
        fulfillmentStatus
        deliveredAt
      }
      activities(order_by: { createdAt: desc }, limit: 1) {
        eventType
        createdAt
      }
    }
  }
`;

export const GET_HOME_BILLING_ACTIVITY = gql`
  query HomeBillingActivity($storeId: uuid!, $limit: Int = 5) {
    recentInvoices: bills(
      where: { storeId: { _eq: $storeId } }
      order_by: { createdAt: desc }
      limit: $limit
    ) {
      id
      storeId
      number
      createdAt
      date
    }
  }
`;

/************
 *
 * ADMIN queries
 * **********
 */

export const GET_ALL_MERCHANT_EMAILS = gql`
  query users($filters: users_bool_exp) {
    users(where: $filters) {
      id
      email
    }
  }
`;

export const GET_ADMIN_USERS = gql`
  query users(
    $filters: users_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [users_order_by]!
  ) {
    users(
      where: $filters
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      avatarUrl
      createdAt
      displayName
      email
      id
      lastSeen
    }
    usersAggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

export const FILTER_ADMIN_USERS = gql`
  query users($filters: users_bool_exp, $order_by: [users_order_by]!) {
    users(where: $filters, order_by: $order_by) {
      avatarUrl
      createdAt
      displayName
      email
      id
      lastSeen
    }
    usersAggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_STORE_MONTHLY_ORDER_VOLUME = gql`
  query GetStoreMonthlyOrderVolume($input: QueryStoreMonthlyOrderVolumeInput!) {
    storeMonthlyOrderVolume(input: $input)
  }
`;

export const GET_ADMIN_USER_BY_ID = gql`
  query users($merchantId: uuid!) {
    users(where: { id: { _eq: $merchantId } }) {
      avatarUrl
      createdAt
      defaultRole
      isAnonymous
      locale
      metadata
      roles {
        role
      }
      displayName
      email
      id
      lastSeen
      stores {
        store {
          createdAt
          completedSteps
          store
          id
          logoUrl
          type
          url
          widgetShowCart
          widgetAutoOptIn
          name
          storeCredit
          domains {
            id
            domain
          }
          plan {
            active
          }
          autoOptInProbability
          onboarding
        }
      }
      invites {
        user {
          avatarUrl
          createdAt
          displayName
          email
          id
          lastSeen
        }
      }
    }
  }
`;

export const GET_ALL_ANNOUNCEMENTS = gql`
  query announcements {
    announcements(order_by: { createdAt: desc }) {
      active
      text
      type
      id
      createdAt
    }
  }
`;

export const GET_ACTIVE_ANNOUNCEMENTS = gql`
  query announcements {
    announcements(
      order_by: { createdAt: desc }
      limit: 1
      where: { active: { _eq: true } }
    ) {
      active
      text
      type
      id
      createdAt
    }
  }
`;

/*
  **
    Tracking and Email Notifications
  **
*/

export const GET_TRACKING_TEMPLATES = gql`
  query trackingTemplates($storeId: uuid!) {
    trackingTemplates(where: { storeId: { _eq: $storeId } }) {
      active
      isTrackingDefault
      createdAt
      eventType
      id
      platformIntegrationType
      sentCount
      storeId
      subject
      templateHtml
      templateJson
      updatedAt
      usage
    }
  }
`;

/*
  **
    Brand Email
  **
*/

export const GET_CUSTOMER_NOTIFICATON_SETTINGS = gql`
  query customerNotificationsSettings($storeId: uuid!) {
    customerNotificationsSettings(where: { storeId: { _eq: $storeId } }) {
      id
      replyToEmail
      replyToName
      senderEmail
      senderName
    }
  }
`;

/*
  **
    Custom Domain and Cover Image for Tracking Page
  **
*/
export const GET_STORE_TRACKING_PAGE_SETTINGS = gql`
  query storesSettings($storeId: uuid!) {
    storesSettings(where: { storeId: { _eq: $storeId } }) {
      customDomain
      trackingPortalCoverImage
      trackingPageConfig
    }
  }
`;

/**
 Claim Automation Rules
 *
 */
export const GET_CLAIM_AUTOMATION_RULES = gql`
  query claimRules($storeId: uuid!) {
    claimRules(
      where: { storeId: { _eq: $storeId } }
      order_by: { priority: asc }
    ) {
      id
      ruleBeforeTransform
      storeId
      active
      action
      priority
      statements
      title
    }
  }
`;

/*
  **
  Referral Program from User
  **
  */
export const GET_USER_REFERRAL_PROGRAM_INFO = gql`
  query {
    getReferralProgramInfo {
      access_token
      expires_in
      hasAccount
    }
  }
`;

/*
  **
  Install Requests
  **
  */
export const GET_INSTALL_REQUESTS = gql`
  query ($where: install_requests_bool_exp!) {
    installRequests(where: $where) {
      id
      storeId
      name
      email
      content
      ticketId
      ticketLink
      installLink
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_ORDER_RISK_PREDICTIONS = gql`
  query ($orderId: uuid!) {
    orderRisksPredictions(where: { orderId: { _eq: $orderId } }) {
      id
      risks
    }
  }
`;

// Get Payment Method Info
export const GET_PAYMENT_METHOD_INFO = gql`
  query getStripePaymentMethodDetail($storeId: String!) {
    getStripePaymentMethodDetail(input: { storeId: $storeId })
  }
`;

// Get App Embed Status
export const GET_APP_EMBED_STATUS = gql`
  query getAppEmbedStatus($storeId: String!) {
    getAppEmbedStatus(input: { storeId: $storeId })
  }
`;

export const CREATE_SUBSCRIPTION_SESSION = gql`
  mutation createSubscriptionSession(
    $input: MutationCreateSubscriptionSessionInput!
  ) {
    createSubscriptionSession(input: $input) {
      url
    }
  }
`;

export const GET_STORE_SETTINGS = gql`
  query GetStoreSettings($storeId: uuid!) {
    storesSettings(where: { storeId: { _eq: $storeId } }) {
      storeId
      availableTags
      availableCollections
    }
  }
`;

export const GET_RETURN_PRODUCT_ELIGIBILITY_CATALOG = gql`
  query returnProductEligibilityCatalog(
    $input: ReturnProductEligibilityCatalogInput!
  ) {
    returnProductEligibilityCatalog(input: $input) {
      capability {
        available
        scopesReady
        apiVersionReady
        catalogSyncedAt
        finalSaleDefinitionReady
        metadataCoverage
      }
      tags {
        id
        label
      }
      collections {
        id
        title
        handle
      }
      finalSaleMetafield {
        namespace
        key
        type
      }
      syncedAt
      stale
      error
    }
  }
`;

/************
 *
 * RETURNS query
 * **********
 */

export const RETURNS_DASHBOARD = gql`
  query returnsDashboard($input: ReturnsDashboardInput!) {
    returnsDashboard(input: $input) {
      buckets {
        bucket
        count
      }
      nodes {
        id
        number
        status
        orderId
        orderNumber
        customerName
        customerEmail
        total
        currencyCode
        requestedResolution
        nextAction
        reviewRequired
        riskLevel
        reviewReasons
        ruleFlags {
          code
          label
          severity
          source
          createdAt
          metadata
        }
        trackingStatus
        trackingNumber
        trackingCarrier
        trackingService
        deadlineAt
        refundDueAt
        updatedAt
      }
    }
  }
`;

/************
 *
 * KLAVIYO query
 * **********
 */

export const GET_KLAVIYO_CONNECTION = gql`
  query klaviyoConnection($storeId: ID!) {
    klaviyoConnection(input: { storeId: $storeId }) {
      connected
      accountName
      templateStyle
      returnTemplateStyle
    }
  }
`;

export const GET_KLAVIYO_TEMPLATE_STYLES = gql`
  query klaviyoTemplateStyles {
    klaviyoTemplateStyles {
      id
      name
      description
    }
  }
`;

export const GET_KLAVIYO_TEMPLATE_PREVIEWS = gql`
  query klaviyoTemplatePreviews($templateStyle: KlaviyoTemplateStyleValue!) {
    klaviyoTemplatePreviews(input: { templateStyle: $templateStyle }) {
      status
      previews {
        eventType
        flowName
        html
      }
    }
  }
`;

export const GET_KLAVIYO_FLOWS_STATUS = gql`
  query klaviyoFlowsStatus(
    $storeId: ID!
    $templateStyle: KlaviyoTemplateStyleValue
  ) {
    klaviyoFlowsStatus(
      input: { storeId: $storeId, templateStyle: $templateStyle }
    ) {
      flowId
      name
      status
      eventType
    }
  }
`;

export const GET_KLAVIYO_FLOW_SETUP_STATUS = gql`
  query klaviyoFlowSetupStatus($storeId: ID!) {
    klaviyoFlowSetupStatus(input: { storeId: $storeId }) {
      status
      created
      failed {
        flowId
        error
      }
      archiveWarning
      error
    }
  }
`;

export const GET_KLAVIYO_FLOW_SEND_COUNTS = gql`
  query klaviyoFlowSendCounts($storeId: ID!, $since: String!, $until: String!) {
    klaviyoFlowSendCounts(
      input: { storeId: $storeId, since: $since, until: $until }
    ) {
      flowId
      name
      sendCount
    }
  }
`;

export const GET_RETURN_KLAVIYO_TEMPLATE_STYLES = gql`
  query returnKlaviyoTemplateStyles {
    returnKlaviyoTemplateStyles {
      id
      name
      description
    }
  }
`;

export const GET_RETURN_KLAVIYO_TEMPLATE_PREVIEWS = gql`
  query returnKlaviyoTemplatePreviews(
    $templateStyle: ReturnKlaviyoTemplateStyleValue!
  ) {
    returnKlaviyoTemplatePreviews(input: { templateStyle: $templateStyle }) {
      status
      previews {
        eventType
        flowName
        html
      }
    }
  }
`;

export const GET_RETURN_KLAVIYO_FLOWS_STATUS = gql`
  query returnKlaviyoFlowsStatus(
    $storeId: String!
    $templateStyle: ReturnKlaviyoTemplateStyleValue
  ) {
    returnKlaviyoFlowsStatus(
      input: { storeId: $storeId, templateStyle: $templateStyle }
    ) {
      flowId
      name
      status
      eventType
    }
  }
`;

export const GET_RETURN_KLAVIYO_FLOW_SETUP_STATUS = gql`
  query returnKlaviyoFlowSetupStatus($storeId: String!) {
    returnKlaviyoFlowSetupStatus(input: { storeId: $storeId }) {
      status
      created
      failed {
        flowId
        error
      }
      archiveWarning
      error
    }
  }
`;

export const GET_RETURN_KLAVIYO_FLOW_SEND_COUNTS = gql`
  query returnKlaviyoFlowSendCounts(
    $storeId: String!
    $since: String!
    $until: String!
  ) {
    returnKlaviyoFlowSendCounts(
      input: { storeId: $storeId, since: $since, until: $until }
    ) {
      flowId
      name
      sendCount
    }
  }
`;

export const GET_RETURN_BILLING_PRICING_STATUS = gql`
  query getReturnBillingPricingStatus($storeId: String!) {
    returnBillingPricingStatus(input: { storeId: $storeId }) {
      storeId
      pricingVersion
      rolloutMode
      effectiveAt
      blockedReason
    }
  }
`;

export const GET_RETURN_BILLING_SUMMARY = gql`
  query getReturnBillingSummary(
    $storeId: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    liveLabels: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        eventType: { _eq: "RETURN_LABEL_PURCHASED" }
        status: { _eq: "SUCCEEDED" }
        rolloutMode: { _eq: "LIVE" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    liveKeepItems: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        eventType: { _eq: "KEEP_ITEM_RESOLVED" }
        status: { _eq: "SUCCEEDED" }
        rolloutMode: { _eq: "LIVE" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    shadowLabels: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        eventType: { _eq: "RETURN_LABEL_PURCHASED" }
        status: { _eq: "SHADOWED" }
        rolloutMode: { _eq: "SHADOW" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    shadowKeepItems: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        eventType: { _eq: "KEEP_ITEM_RESOLVED" }
        status: { _eq: "SHADOWED" }
        rolloutMode: { _eq: "SHADOW" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    pending: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        status: { _eq: "PENDING" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    failed: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        currencyCode: { _eq: "USD" }
        status: { _eq: "FAILED" }
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
    invalidCurrency: returnBillingEventsAggregate(
      where: {
        storeId: { _eq: $storeId }
        pricingVersion: { _eq: 2 }
        occurredAt: { _gte: $startDate, _lte: $endDate }
        _or: [
          { currencyCode: { _is_null: true } }
          { currencyCode: { _neq: "USD" } }
        ]
      }
    ) {
      aggregate {
        count
        sum {
          amount
          carrierCost
          serviceFee
        }
      }
    }
  }
`;

export const GET_RETURN = gql`
  query getReturn($storeId: String!, $id: String!) {
    returnRecord: getReturn(input: { storeId: $storeId, id: $id }) {
      id
      number
      orderId
      status
      requestedResolution
      businessStatus
      businessStatusLabel
      nextAction
      reviewRequired
      riskLevel
      reviewReasons
      ruleFlags {
        code
        label
        severity
        source
        createdAt
        metadata
      }
      deadlineAt
      customerNotes
      images
      videos
      denialReason
      denialDescription
      createdAt
      updatedAt
      eligibleAt
      eligibleUntil
      approvedAt
      labelCreatedAt
      shipByAt
      expiredAt
      firstCarrierScanAt
      inboundDeliveredAt
      receivedAt
      refundDueAt
      refundedAt
      storeCreditIssuedAt
      settlementStatus
      settlementType
      settlementTriggeredAt
      settlementCompletedAt
      settlementFailureReason
      trackingStatus
      trackingUpdatedAt
      storeId
      shippingId
      deflectionOption
      meta
      policySnapshot
      labelUrl
      carrier
      service
      labelCost
      labelSource
      selectedShippingOption
      trackingNumber
      shopifyReturnId
      shopifyReturnName
      shopifyReturnStatus
      shopifyReverseFulfillmentOrderIds
      shopifyReturnSyncedAt
      shopifyReturnSyncStatus
      shopifyReturnSyncError
      shopifyReturnLastWebhookAt
      order {
        id
        orderId
        number
        customerName
        customerEmail
        customerPhone
        total
        createdAt
        subtotal
        shippingTotal
        tax
        paymentCurrencyCode
        currencyCode
      }
      returnItems {
        id
        orderItemId
        quantity
        reason
        reasonComments
        requestedResolution
        resolution
        orderItem {
          id
          title
          sku
          price
          total
          quantity
          imageSrc
        }
      }
      events {
        id
        type
        source
        occurredAt
        payload
      }
      policy {
        eligible
        approvalMode
        dynamicFees {
          label
          type
          value
        }
        deflectionOffers {
          id
          type
          offerType
          label
          value
          valueType
        }
      }
    }
  }
`;

export const GET_TRACKING_AD_PRODUCTS = gql`
  query trackingAdProducts($input: QueryTrackingAdProductsInput!) {
    trackingAdProducts(input: $input) {
      id
      title
      description
      imageUrl
      url
    }
  }
`;

export const GET_OUTBOUND_SHIPMENT_ALERT_SETTINGS = gql`
  query getOutboundShipmentAlertSettings(
    $input: GetOutboundShipmentAlertSettingsInput!
  ) {
    getOutboundShipmentAlertSettings(input: $input) {
      storeId
      channel
      recipientUserIds
      recipientEmails
      policies {
        type
        enabled
        thresholdDays
      }
    }
  }
`;

export const INSPIRED_MERCHANT_REPORT = gql`
  query inspiredMerchantReport($input: InspiredMerchantReportInput!) {
    inspiredMerchantReport(input: $input) {
      storeId
      currency
      status
      message
      summary {
        totalGiftCount
        totalGiftAmount
        totalRedemptionCount
        totalRedeemedAmount
        periods {
          periodStart
          giftCount
          giftAmount
          redemptionCount
          redeemedAmount
        }
        campaigns {
          incentiveId
          giftCount
          giftAmount
          redemptionCount
          redeemedAmount
        }
        causes {
          charityId
          charityName
          causeId
          causeName
          isPendingRedemption
          giftCount
          giftAmount
          redemptionCount
          redeemedAmount
        }
      }
      recentActivity {
        items {
          reference
          orderId
          orderNumber
          incentiveId
          giftAmount
          redeemedAt
          isRedeemed
          charityId
          charityName
          causeId
          causeName
          createdAt
          refreshedAt
        }
        pagination {
          limit
          offset
          count
          hasMore
        }
      }
      freshness {
        refreshedAt
        earliestRefreshedAt
        latestRefreshedAt
        isStale
      }
    }
  }
`;

export const MERCHANT_TREE_RECORD_REPORT = gql`
  query merchantTreeRecordReport($input: MerchantTreeRecordReportInput!) {
    merchantTreeRecordReport(input: $input) {
      storeId
      status
      dateBasis
      from
      to
      recordedOrderCount
      refundedRecordedOrderCount
      activeRecordedOrderCount
    }
  }
`;

export const GET_INSTALLATION_PREFERENCES = gql`
  query installationPreferences($storeId: uuid!) {
    storeInstallationPreferences(storeId: $storeId) {
      storeId
      preferences
      revision
    }
  }
`;

export const GET_INSTALLATION_PREVIEW_WORKSPACE = gql`
  query InstallationPreviewWorkspace($input: InstallationPreviewStoreInput!) {
    installationPreviewWorkspace(input: $input)
  }
`;
